import React, { useState, useEffect } from 'react';
import { servicesService } from '../../../services/servicesService';

const ManageServices = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const data = await servicesService.getAllServices();
            setServices(data.services || data);
        } catch (error) {
            console.error("Failed to fetch services", error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this service?")) {
            try {
                await servicesService.deleteService(id);
                fetchServices(); // refresh list
            } catch(err) {
                console.error("Failed to delete", err);
            }
        }
    };

    return (
        <div className="py-24 bg-slate-50 min-h-screen mt-16 px-6 sm:px-8 lg:px-10">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">Manage <span className="text-amber-500">Services</span></h2>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>
                
                <div className="bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-slate-100">
                    {services.length === 0 ? (
                        <div className="py-24 text-center text-slate-400 font-medium italic">No services found. Add some services first.</div>
                    ) : (
                        <div className="overflow-x-auto scrollbar-hide">
                            <table className="min-w-full divide-y divide-slate-100">
                                <thead className="bg-slate-900">
                                    <tr>
                                        <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Service Title</th>
                                        <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Description</th>
                                        <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-slate-100">
                                    {services.map((svc) => (
                                        <tr key={svc._id} className="hover:bg-slate-50 transition-colors group">
                                            <td className="px-8 py-6 whitespace-nowrap text-sm font-bold text-slate-800">
                                                <div className="flex items-center">
                                                    <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center mr-4 group-hover:bg-amber-500 group-hover:text-slate-900 transition-all duration-300">
                                                        <i className={`${svc.icon} text-lg text-amber-500 group-hover:text-inherit`}></i> 
                                                    </div>
                                                    {svc.title}
                                                </div>
                                            </td>
                                            <td className="px-8 py-6 text-sm text-slate-500 font-medium truncate max-w-xs">{svc.description}</td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center">
                                                <button 
                                                    onClick={() => handleDelete(svc._id)}
                                                    className="bg-red-500/10 text-red-600 hover:bg-red-600 hover:text-white p-3 rounded-2xl transition-all shadow-sm border border-transparent hover:border-red-200"
                                                    title="Delete"
                                                >
                                                    <i className="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ManageServices;
